import React from 'react';

import o1 from '../images/o1.jpg';
import o2 from '../images/o2.jpg';
import o3 from '../images/o3.jpg';
import o4 from '../images/o4.jpg';
import o5 from '../images/o5.jpg';
import o6 from '../images/o6.jpg';
import custom_photo_frame from '../images/custom_photo_frame.jpg';
import magic_mirror from '../images/magic_mirror.jpg';
import custom_mug from '../images/custom_mug.jpg';
import cushion_cover from '../images/cushion_cover.jpg';

const services = [
    {
        title: 'Wedding Cards',
        image: o5,
        desc: 'Letterpress, foil-stamped, hand-stitched. Three generations of Jaipur weddings.',
        tags: ['Foil', 'Bilingual', 'Letterpress'],
    },
    {
        title: 'Stamps',
        image: o1,
        desc: 'Rubber stamps, pre-inked, self-inking. Order on WhatsApp, pick up in 24 hours.',
        tags: ['Rubber', 'Pre-inked', '24h'],
    },
    {
        title: 'Leaflets & Pamphlets',
        image: o2,
        desc: 'Single-side, double-side, tri-fold, A6 to A2. Same-day for digital runs.',
        tags: ['Same-day', 'Tri-fold'],
    },
    {
        title: 'Flex & Standees',
        image: o3,
        desc: 'Banners, hoardings, flex, vinyl. Up to 10 ft wide for indoor and outdoor.',
        tags: ['Flex', 'Vinyl', 'Up to 10ft'],
    },
    {
        title: 'Offset Printing',
        image: o6,
        desc: 'Long runs, short runs, screen, digital. The right press for the job.',
        tags: ['Offset', 'Long runs'],
    },
    {
        title: 'Custom Mugs',
        image: custom_mug,
        desc: 'Personalised photo mugs, magic mugs, ceramic and steel — a gift that lasts.',
        tags: ['Personalised', 'Photo'],
    },
    {
        title: 'Magic Mirror',
        image: magic_mirror,
        desc: 'A mirror that reveals your photo only when lit. The party trick that prints.',
        tags: ['Custom'],
    },
    {
        title: 'Cushion Covers',
        image: cushion_cover,
        desc: 'Sublimation prints on soft satin. Pet portraits, family photos, your call.',
        tags: ['Sublimation'],
    },
    {
        title: 'Photo Frames',
        image: custom_photo_frame,
        desc: 'Wood, acrylic, collage frames. We print, mount, and finish in-house.',
        tags: ['Wood', 'Acrylic'],
    },
    {
        title: 'And much more',
        image: o4,
        desc: 'Boxes, stickers, ID cards, lanyards, bookmarks. If it takes ink, ask us.',
        tags: ['Just ask'],
    },
];

function OurWorkSection() {
    return (
        <section id="work" className="bd-catalogue">
            <div className="bd-catalogue__head">
                <div>
                    <div className="bd-catalogue__eyebrow">◆ 01 / What we make</div>
                    <h2 className="bd-catalogue__h2">
                        A small catalogue<br />
                        <em>of our offerings.</em>
                    </h2>
                </div>
                <p className="bd-catalogue__intro">
                    Ten things we do every day, plus a hundred we do on request. Bring the brief —
                    we will find the paper, the ink, and the press.
                </p>
            </div>

            <div className="bd-catalogue__grid">
                {services.map((s, i) => (
                    <article key={s.title} className="bd-cat-card">
                        <div className="bd-cat-card__top">
                            <span className="bd-cat-card__num">
                                № {String(i + 1).padStart(2, '0')}
                            </span>
                            <span className="bd-cat-card__arrow" aria-hidden>↗</span>
                        </div>
                        <div className="bd-cat-card__photo">
                            <img src={s.image} alt={s.title} />
                        </div>
                        <h3 className="bd-cat-card__title">{s.title}</h3>
                        <p className="bd-cat-card__desc">{s.desc}</p>
                        <div className="bd-cat-card__tags">
                            {s.tags.map((t) => (
                                <span key={t} className="bd-cat-card__tag">{t}</span>
                            ))}
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default OurWorkSection;
